import "./App.css";
import Nav from "./components/marie/Nav";
import ScrollProgress from "./components/marie/ScrollProgress";
import Hero from "./components/marie/Hero";
import FounderSection from "./components/marie/FounderSection";
import ParentTribute from "./components/marie/ParentTribute";
import SustainableTech from "./components/marie/SustainableTech";
import Gallery from "./components/marie/Gallery";
import Awards from "./components/marie/Awards";
import Specifications from "./components/marie/Specifications";
import Opportunity from "./components/marie/Opportunity";
import Comparison from "./components/marie/Comparison";
import FinalCTA from "./components/marie/FinalCTA";
import Footer from "./components/marie/Footer";

function App() {
  return (
    <div className="App" data-testid="marie-joseph-app">
      <Nav />
      <ScrollProgress />
      <main>
        <Hero />
        <FounderSection />
        <ParentTribute />
        <SustainableTech />
        <Gallery />
        <Awards />
        <Specifications />
        <Opportunity />
        <Comparison />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
